// extracted by mini-css-extract-plugin
export default {"root":"FormSubmitButton_root__DaD6d"};